import React, {useState} from 'react';
import { DismissRegular } from '@fluentui/react-icons';
import {
    MessageBar,
    MessageBarActions,
    MessageBarBody,
    MessageBarTitle,
    Button,
    Link,
} from '@fluentui/react-components';

interface ScriptRetryProps {
    rerunChoice: (rerun: boolean) => void;
    customMsg: boolean 
}

const ScriptRetryPrompt: React.FC<ScriptRetryProps> = ({ rerunChoice, customMsg }) => {

    const displayMessage = () => {
        if(customMsg) {
            return "We apologize for the inconvenience, an unexpected error occurred. We suggest you start a new session or try again in a few minutes."
        }
        else {
            return "Looks like there is an error with the script. Do you want to re-try script generation? "
        }
    }
    const handleYes = () => {
        rerunChoice(true);
    };

    const handleNo = () => {
        rerunChoice(false);
    };

    return (
        <MessageBar intent='error' style={{ padding: '12px', opacity: '0.7' }}>
            <MessageBarBody>
                 {customMsg === false? <MessageBarTitle>Script Error</MessageBarTitle> : 
                 <MessageBarTitle>Server Error</MessageBarTitle>  }
                  {displayMessage()}
            </MessageBarBody>
            {customMsg=== true ? <> </> : 
            <MessageBarActions
                containerAction={
                    <Button
                        appearance="transparent"
                        icon={<DismissRegular />}
                        onClick={handleNo}
                    />
                }
            >
                
                <Button onClick={handleYes}>Yes</Button>
                <Button onClick={handleNo}>No</Button>
            </MessageBarActions>
}
        </MessageBar>
    );
};

export default ScriptRetryPrompt;
